
let language = {
    FILE_LIBRARY_BAR_SEARCH_BTN: "搜索",
    FILE_LIBRARY_BAR_RESET_BTN: "重置",
    FILE_LIBRARY_BAR_UPLOAD_BTN: "上传文件",
    FILE_LIBRARY_BAR_SEARCH_TYPE_PLACEHOLDER: "搜索文件库",
    FILE_LIBRARY_BAR_SEARCH_ALL_PLACEHOLDER: "全部",
    
    // 
    "fileLibrary:Sort:Created:Newest": "创建时间：最新",
    "fileLibrary:Sort:Created:Oldest": "创建时间：最早",
    "fileLibrary:Sort:Name:Asc": "名称: A 到 Z",
    "fileLibrary:Sort:Name:Desc": "名称: Z 到 A",
    
    "fileLibrary:Filter:AllType": "所有类型",
    "fileLibrary:Filter:Catalog": "文件夹",
    "fileLibrary:Filter:FileObject": "文件"
};

export { language }